import { Helmet } from "react-helmet-async";
import { Header } from "@/components/layout/Header.tsx";
import { Footer } from "@/components/layout/Footer.tsx";
import { ContactHero } from "@/components/sections/ContactHero.tsx";
import { ContactForm } from "@/components/sections/ContactForm.tsx";
import siteData from "@/data/site.json";

export function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact Us - {siteData.title}</title>
        <meta name="description" content="Get in touch with Concierge Couples Counseling. Schedule your complimentary consultation today." />
      </Helmet>
      <div className="min-h-screen bg-white">
        <Header />
        <main className="pt-0">
          <ContactHero />
          <ContactForm />
        </main>
        <Footer />
      </div>
    </>
  );
}